/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Charspage_TitleInputs */

const en_fw_charspage_title = /** @type {(inputs: Fw_Charspage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding characters`)
};

const zh_fw_charspage_title = /** @type {(inputs: Fw_Charspage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁角色图鉴`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding characters" |
*
* @param {Fw_Charspage_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_charspage_title = /** @type {((inputs?: Fw_Charspage_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Charspage_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_charspage_title(inputs)
	return zh_fw_charspage_title(inputs)
});
export { fw_charspage_title as "fw.charspage.title" }